import { FormControlLabel, Switch, Tooltip, Typography } from '@mui/material';
import React from 'react';

type LabelPlacementT = 'start' | 'end' | 'top' | 'bottom';

type Props = {
    title: string;
    tooltipTitle: string;
    isChecked?: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    titlePosition?: LabelPlacementT;
};

const ToggleWithTooltip = ({
    title,
    tooltipTitle,
    isChecked = false,
    onChange,
    titlePosition = 'end',
}: Props): React.ReactElement => {
    return (
        <Tooltip title={tooltipTitle}>
            <FormControlLabel
                control={<Switch checked={isChecked} onChange={onChange} />}
                disableTypography
                label={<Typography>{title}</Typography>}
                labelPlacement={titlePosition}
            />
        </Tooltip>
    );
};
export default ToggleWithTooltip;
